import React, { useState } from "react";
import { Grid, IconButton, Typography, Card, Box } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { styled } from "@mui/system";
import DetailsList from "./DetailedList";

const StyledFarmerCard = styled(Card)({
  border: "1px solid #A5A5A5",
  marginBottom: "10px",
});

const FarmerCardContent = styled(Box)({
  padding: "10px",
});

const FarmerCard = ({ farmer, t, buttons, detailsDropDown }) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const detailsData = detailsDropDown || [
    { label: t("Farming Since"), value: farmer.farming_since_year },
    { label: t("Crops Covered"), value: farmer.crops_covered },
    // Add more label-value pairs as needed
  ];

  return (
    <>
      <StyledFarmerCard>
        <FarmerCardContent>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item xs={10}>
              <Typography variant="h6">{farmer.app_user.full_name}</Typography>
            </Grid>
            <Grid item xs={2} style={{ textAlign: "right" }}>
              <IconButton onClick={handleExpandClick}>
                {expanded ? (
                  <ExpandLess sx={{ fill: "#4CAF50", fontSize: "20px" }} />
                ) : (
                  <ExpandMore sx={{ fill: "#4CAF50" }} />
                )}
              </IconButton>
            </Grid>
          </Grid>
        </FarmerCardContent>
      </StyledFarmerCard>
      {expanded && (
        <DetailsList
          data={detailsData}
          buttonList={
            !buttons ? [t("View Farmer"), t("Farm Map Location")] : []
          }
        />
      )}
    </>
  );
};

export default FarmerCard;
